module.exports = __webpack_public_path__ + "img/www.bbb.com.12a6fbcc.png";